import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=a8f4b47c&scoped=true&"
import script from "./Mobile.vue?vue&type=script&lang=ts&"
export * from "./Mobile.vue?vue&type=script&lang=ts&"
import style0 from "./Mobile.vue?vue&type=style&index=0&id=a8f4b47c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f4b47c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a8f4b47c', component.options)
    } else {
      api.reload('a8f4b47c', component.options)
    }
    module.hot.accept("./Mobile.vue?vue&type=template&id=a8f4b47c&scoped=true&", function () {
      api.rerender('a8f4b47c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/learningPathV2/Mobile.vue"
export default component.exports